import { ArrowUpDown } from "lucide-react";
import { useState } from "react";
import type { Key } from "react-aria";

export const useSort = <T extends string | undefined>(initial: T, initialDirection: "asc" | "desc" = "desc") => {
  const [sort, setSort] = useState<{ column: T; direction: "asc" | "desc" }>({
    column: initial,
    direction: initialDirection,
  });

  const cycleSort = (selected: T) => {
    setSort((prev) => {
      if (selected !== prev.column)
        return {
          column: selected,
          direction: "desc",
        };
      if (prev.direction === "desc")
        return {
          column: prev.column,
          direction: "asc",
        };
      if (initial !== undefined)
        return {
          column: prev.column,
          direction: "desc",
        };

      return {
        column: undefined as T,
        direction: "desc",
      };
    });
  };

  const sortHeader = (key: T) => {
    if (sort.column === key) {
      return <span>{sort.direction === "asc" ? "↑" : "↓"}</span>;
    }
    return <ArrowUpDown className="h-3 w-3" />;
  };

  const setFromDescriptor = ({ column, direction }: { column: Key; direction: "descending" | "ascending" }) => {
    setSort({ column: column as T, direction: direction === "ascending" ? "asc" : "desc" });
  };

  return {
    sort,
    cycleSort,
    sortHeader,
    descriptor: {
      column: sort.column,
      direction: sort.direction === "desc" ? ("descending" as const) : ("ascending" as const),
    },
    setFromDescriptor,
  };
};
